/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'bug-check': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M18 7h-2.81c-.45-.8-1.07-1.5-1.82-2L15 3.41 13.59 2l-2.17 2.17a6.002 6.002 0 00-2.83 0L6.41 2 5 3.41 6.62 5c-.75.5-1.36 1.21-1.81 2H2v2h2.09c-.06.33-.09.66-.09 1v1H2v2h2v1c0 .34.03.67.09 1H2v2h2.81A6.002 6.002 0 0012 19.65V19c0-2.54 1.61-4.8 4-5.65V13h2v-2h-2v-1c0-.34-.03-.67-.09-1H18V7m-6 8H8v-2h4v2m0-4H8V9h4v2m5.75 11.16l-2.75-3L16.16 18l1.59 1.59L21.34 16l1.16 1.41-4.75 4.75z"/>'
  }
})
